import { createStore } from 'satcheljs';
import { ObservableMap } from 'mobx';
import type { RoomAvailabilityState } from './schema/RoomAvailabilityState';

export interface RoomAvailabilityStates {
    roomAvailabilityStates: ObservableMap<string, RoomAvailabilityState>;
}

const defaultRoomAvailabilityStates: RoomAvailabilityStates = {
    roomAvailabilityStates: new ObservableMap<string, RoomAvailabilityState>(),
};

export const getRoomAvailabilityStore = createStore<RoomAvailabilityStates>(
    'roomAvailabilityStore',
    defaultRoomAvailabilityStates
);
export default getRoomAvailabilityStore;
